import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { Button } from 'components/Button/Button'
import InfoModal from 'components/InfoModal/InfoModal'
import { useState } from 'react'
import Styles from './DeactivateUser.module.scss'
import { UserClient } from 'api/clients/UserClient'
import { useSession } from 'hooks/useSession'
import { useModals } from 'almanac-ui/Modal'
import { sendMessageToNativeApp } from 'utils/sendMessageToNativeApp'

export const DeactivateUser = () => {
  const [deactivateModalVisible, setDeactivateModalVisible] = useState(false)
  const { logout } = useSession()
  const { closeAllModals } = useModals()

  return (
    <>
      <InfoModal
        onOk={() => {
          UserClient.deactivate().then((e) => {
            if (e.type === SUCCESS_RESPONSE_TYPE) {
              closeAllModals()
              logout()
              sendMessageToNativeApp('delete_account_complete')
            } else {
              showErrorMessageToast('Something went wrong, please try again later')
            }
          })

          return true
        }}
        okText="Yes, delete my account"
        cancelText="No, cancel"
        title={`Delete your account`}
        visible={deactivateModalVisible}
        setVisible={setDeactivateModalVisible}
      >
        Are you sure you want to delete your account? All your data will be removed. This action cannot be undone.
        Please note this action will not cancel any active subscriptions you have.
      </InfoModal>
      <Button
        className={Styles.deactivateButton}
        size="md"
        variant="secondary"
        onPress={() => setDeactivateModalVisible(true)}
        data-testid="deactivate"
      >
        Delete Account
      </Button>
    </>
  )
}
